import axios from "axios";

let headers = {
  "Content-Type": "application/json",
};

const axiosInstance = axios.create({
  headers,
  timeout: 1600000,
  baseURL: process.env.REACT_APP_BASE_URL,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const userAppToken = localStorage.getItem("userAppToken");
    const ctToken = localStorage.getItem("ctToken");
   
    // Check if the request URL contains `/user`
    if (config.url?.startsWith("user") && userAppToken)
      config.headers["Authorization"] = `Bearer ${userAppToken}`;
    else if (ctToken) config.headers["Authorization"] = `Bearer ${ctToken}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    try {
      if (axios.isCancel(error)) {
        console.log("Request canceled", error?.message);
        return Promise.reject(error);
      }
    } catch (error) { }

    return Promise.reject(error);
  }
);

export default axiosInstance;
